export default __webpack_public_path__ + "static/media/img_about_content-3.42bf72c7.png";